
  import exchangeReward from '~/mixins/pages/mission-control/exchangeReward'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2MissionMobileExchangeRewardPage',
    mixins: [exchangeReward, vipSettings],
    computed: {},
    mounted() {
      this.getVipSettings() // It's from mixins->vipSettings.js
      this.getPlayerVipTier() //  mixins->vipSettings.js
    }
  }
